<template>
  <v-menu
      v-model="visible"
      :close-on-content-click="false"
      max-width="400"
  >
    <template v-slot:activator="{ on, attrs }">
      <span v-if="textAsInput" v-bind="attrs" v-on="on">
        {{ text }}
      </span>
      <v-text-field
          v-else
          :filled="!!filled"
          v-model="text"
          :label="label !== undefined ? label : $t('label')"
          :prepend-icon="$vuetify.breakpoint.smAndUp ? (icon !== undefined ? icon : 'mdi-puzzle-edit-outline') : ''"
          readonly
          hide-details
          v-bind="attrs"
          v-on="on"
      ></v-text-field>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-row dense>
            <v-col cols="12">
              <v-select
                  v-model="fields.synthesis"
                  :items="items.synthesis"
                  :label="$t('label-synthesis')"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  v-model="fields.only_favorites"
                  :items="items.only_favorites"
                  :label="$t('label-only-favorites')"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  v-model="fields.sort_by"
                  :items="items.sort_by"
                  :label="$t('label-table-sort')"
              ></v-select>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>

        <v-btn text @click="visible = false" class="grey--text">
          {{ $t('actions.close') }}
        </v-btn>
        <v-btn v-if="enableSave" text @click="save" class="primary--text">
          {{ $t('actions.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ExportOptionsSelect',
  props: ['label', 'icon', 'filled', 'value', 'textAsInput', 'enableSave'],
  data () {
    return {
      visible: false,
      fields: {
        only_favorites: 'no',
        sort_by: 'volume',
        synthesis: 'yes',
        ...this.value,
      },
      items: {
        only_favorites: [
          { value: 'no', text: this.$t('favorites-all-keywords') },
          { value: 'on_table', text: this.$t('favorites-on-table') },
          { value: 'on_synthesis', text: this.$t('favorites-on-synthesis') },
          { value: 'everywhere', text: this.$t('favorites-everywhere') },
        ],
        sort_by: [
          { value: 'volume', text: this.$t('sort-by-volume') },
          { value: 'variation', text: this.$t('sort-by-variation') },
          { value: 'name', text: this.$t('sort-by-name') },
        ],
        synthesis: [
          { value: 'yes', text: this.$t('synthesis-yes') },
          { value: 'no', text: this.$t('synthesis-no') },
        ],
      }
    }
  },
  computed: {
    text () {
      let text = []

      text.push(this.items.synthesis.find(item => item.value === this.fields.synthesis).text)
      text.push(this.items.only_favorites.find(item => item.value === this.fields.only_favorites).text)
      text.push(this.items.sort_by.find(item => item.value === this.fields.sort_by).text)

      return text.join(', ')
    }
  },
  watch: {
    fields: {
      handler: function (val) {
        this.$emit('update:value', val)
      },
      deep: true
    }
  },
  methods: {
    save () {
      this.$emit('save', this.fields)
      this.visible = false
    }
  },
  mounted () {
    this.$emit('update:value', this.fields)
  }
}
</script>

<i18n>
{
	"en": {
		"favorites-all-keywords": "All Keywords",
		"favorites-everywhere": "Favorites only on table and synthesis",
		"favorites-on-synthesis": "Favorites only on synthesis",
		"favorites-on-table": "Favorites only on the table",
		"label-only-favorites": "Filtering on favorites",
		"label-synthesis": "Synthesis display",
		"label-table-sort": "Table sort",
		"sort-by-name": "Sort by name (asc)",
		"sort-by-variation": "Sort by variation (desc)",
		"sort-by-volume": "Sort by volume (desc)",
		"synthesis-no": "Hide synthesis",
		"synthesis-yes": "Show synthesis"
	},
	"es": {
		"favorites-all-keywords": "Todas las palabras clave",
		"favorites-everywhere": "Favoritos solo en tabla y gráfico",
		"favorites-on-synthesis": "Favoritos solo en síntesis",
		"favorites-on-table": "Favoritos solo en el tablero de datos",
		"label-only-favorites": "Filtrado en favoritos",
		"label-synthesis": "Pantalla de resumen",
		"label-table-sort": "ordenación de matriz",
		"sort-by-name": "Ordenar por nombre (asc)",
		"sort-by-variation": "Ordenar por variación (desc)",
		"sort-by-volume": "Ordenar por volumen (desc)",
		"synthesis-no": "Ocultar resumen",
		"synthesis-yes": "Mostrar resumen"
	},
	"fr": {
		"favorites-all-keywords": "Tous les mots clés",
		"favorites-everywhere": "Favoris seulement sur le tableau et le graphique",
		"favorites-on-synthesis": "Favoris seulement sur la synthèse",
		"favorites-on-table": "Favoris seulement sur le tableau de données",
		"label-only-favorites": "Filtrage sur les favoris",
		"label-synthesis": "Affichage de la synthèse",
		"label-table-sort": "Tri du tableau",
		"sort-by-name": "Trier par nom (asc)",
		"sort-by-variation": "Trier par variation (desc)",
		"sort-by-volume": "Trier par volume (desc)",
		"synthesis-no": "Cacher la synthèse",
		"synthesis-yes": "Afficher la synthèse"
	},
	"it": {
		"favorites-all-keywords": "Tutte le parole chiave",
		"favorites-everywhere": "Preferiti solo su tabella e grafico",
		"favorites-on-synthesis": "Preferiti solo sulla sintesi",
		"favorites-on-table": "Preferiti solo sulla tabella dei dati",
		"label-only-favorites": "Filtraggio sui preferiti",
		"label-synthesis": "Visualizzazione sintesi",
		"label-table-sort": "Ordinamento tabella",
		"sort-by-name": "Ordina per nome (asc)",
		"sort-by-variation": "Ordina per variazione (desc)",
		"sort-by-volume": "Ordina per volume (desc)",
		"synthesis-no": "Nascondi sintesi",
		"synthesis-yes": "Mostra sintesi"
	},
	"pt": {
		"favorites-all-keywords": "Todas as palavras-chave",
		"favorites-everywhere": "Favoritos apenas na tabela e síntese",
		"favorites-on-synthesis": "Favoritos apenas na síntese",
		"favorites-on-table": "Favoritos apenas na tabela de dados",
		"label-only-favorites": "Filtrar favoritos",
		"label-synthesis": "Exibição da síntese",
		"label-table-sort": "Ordenação da tabela",
		"sort-by-name": "Ordenar por nome (asc)",
		"sort-by-variation": "Ordenar por variação (desc)",
		"sort-by-volume": "Ordenar por volume (desc)",
		"synthesis-no": "Ocultar síntese",
		"synthesis-yes": "Mostrar síntese"
	},
	"pl": {
		"favorites-all-keywords": "Wszystkie słowa kluczowe",
		"favorites-everywhere": "Ulubione tylko w tabeli i podsumowaniu",
		"favorites-on-synthesis": "Ulubione tylko w podsumowaniu",
		"favorites-on-table": "Ulubione tylko w tabeli danych",
		"label-only-favorites": "Filtrowanie ulubionych",
		"label-synthesis": "Wyświetlanie podsumowania",
		"label-table-sort": "Sortowanie tabeli",
		"sort-by-name": "Sortuj po nazwie (rosnąco)",
		"sort-by-variation": "Sortuj po zmianie (malejąco)",
		"sort-by-volume": "Sortuj po wolumenie (malejąco)",
		"synthesis-no": "Ukryj podsumowanie",
		"synthesis-yes": "Pokaż podsumowanie"
	}
}
</i18n>